<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'BJU',

    metaInfo: { title: 'BJU Dashboard' },

    extends: View,

    mixins: [
      LoadSections([
        'bju',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'BJU',
      },
    },
  }
</script>
